import { Map, List, fromJS } from 'immutable'
import _set from 'lodash/set'
import _get from 'lodash/get'
import _parseInt from 'lodash/parseInt'
import _isUndefined from 'lodash/isUndefined'
import _toNumber from 'lodash/toNumber'
import _max from 'lodash/max'
import _isEmpty from 'lodash/isEmpty'
import retry from 'retry-as-promised'
import { getAuthIsLoggedIn, DEVICE } from 'services/auth'
import { emarsysSend } from 'services/emarsys'
import FingerprintJS from '@fingerprintjs/fingerprintjs-pro'
import { SET_RESOLVER_DATA } from 'services/resolver/actions'
import { SET_APP_BOOTSTRAP_PHASE } from 'services/app/actions'
import { get as getCookie } from 'cookies-js'
import {
  CREATE_SERVER_EVENT,
  SET_EVENT_LEAD,
  setDefaultGa4Event,
} from 'services/event-tracking/actions'
import { PAYMENT_PROVIDER_NAME_ZUORA } from 'services/paytrack'
import { SET_PAYTRACK_DATA_LAST_TRANSACTION } from 'services/paytrack/actions'
import { SET_USER_ACCOUNT_DATA_BILLING_SUBSCRIPTIONS_WITH_DETAILS } from 'services/user-account/actions'
import { userCreate, USER_CREATION_SOURCE_ZUORA } from 'services/user'
import {
  SET_USER_DATA_ENTITLED,
  SET_USER_PROCESSING,
  SET_USER_DATA,
  SET_USER_CREATE_PROCESSING,
  SET_USER_CREATE_DATA,
  getUserEmailAvailability,
  SET_USER_CHILD_ACCOUNT,
} from 'services/user/actions'
import { removeInterstitial } from 'services/interstitial/actions'
import {
  setPlansLocalizedSelection,
  getPlansData,
  SET_PLANS_DATA,
  SET_PLANS_SELECTION,
  SET_PLANS_LOCALIZED_PROCESSING,
} from 'services/plans/actions'
import { NAVIGATION_HISTORY_PUSH } from 'services/navigation/actions'
import { checkVelocity, getVelocityCheckActionLocation } from 'services/velocity-check'
import {
  updateAdyenAuthorization,
  ADYEN_PAYMENT_RESPONSE_CODE_AUTHORIZED,
  ADYEN_PAYMENT_TYPE_PAYPAL,
} from 'services/adyen'
import {
  SET_PAYMENT_DATA,
} from 'services/payment/actions'
import {
  SET_VELOCITY_CHECK_PROCESSING,
  SET_VELOCITY_CHECK_DATA,
} from 'services/velocity-check/actions'
import {
  doAuthRenew,
  setAuthPersistentData,
  setAuthLoginSuccess,
  setAuthLoginFailed,
  SET_AUTH_LOGIN_SUCCESS,
  SET_AUTH_LOGIN_FAILED,
  AUTH_LOGIN,
  AUTH_ERROR,
} from 'services/auth/actions'
import { setFeatureTrackingDataPersistent } from 'services/feature-tracking/actions'
import { setMessageBoxVisible } from 'components/MessageBox/actions'
import {
  SERVER_EVENT_PURCHASE,
  FACEBOOK_EVENT_NAME_PURCHASE,
  FACEBOOK_EVENT_ACTION_SOURCE,
  getPurchasedPlanEventData,
  buildCheckoutEcommerceObject,
  SIGN_UP_GA4_EVENT,
  BEGIN_CHECKOUT_GA4_EVENT,
  PURCHASE_GA4_EVENT,
  PAYMENT_INFO_PAGE_GA4_EVENT,
  PAYPAL_POPUP_OPENED_GA4_EVENT,
} from 'services/event-tracking'
import { setContentImpression } from 'services/content-impressions'
import { requestAnimationFrame } from 'services/animate'
import {
  format as formatDateTime,
  getUnixTimestamp,
} from 'services/date-time'
import {
  ACCOUNT_TYPE_FMTV_GIFT,
  ACCOUNT_TYPE_FMTV_COMP,
  ACCOUNT_TYPE_ZUORA_GIFT,
  USER_ACCOUNT_UNENTITLED,
} from 'services/user-account'
import {
  planIsGift,
  PLAN_ID_LIVE,
} from 'services/plans'
import {
  getUserEntitled,
  isEntitled,
} from 'services/subscription'
import { EN } from 'services/languages/constants'
import {
  CHECKOUT_STEP_ONE,
  CHECKOUT_STEP_TWO,
  CHECKOUT_STEP_THREE,
  CHECKOUT_EVENT_STEP_ONE,
  CHECKOUT_EVENT_STEP_TWO,
  CHECKOUT_EVENT_STEP_THREE,
  CHECKOUT_EVENT_STEP_FOUR,
  CHECKOUT_EVENT_STEP_FIVE,
  CHECKOUT_EVENT_STEP_SIX,
  CHECKOUT_EVENT_STEP_SEVEN,
  CHECKOUT_ORDER_ERROR_TYPE_UNKNOWN,
  CHECKOUT_ASYNC_DELAY_MILLISECONDS,
  CHECKOUT_ASYNC_MAX_ATTEMPTS,
  userCheckoutAllowed,
  getCheckoutOrderData,
  userCheckoutAccountChangePlanAllowed,
} from 'services/checkout'
import {
  isCart,
  isPlans,
  isCartAccessDenied,
  isGo,
  isLogout,
  isCartConfirmation,
  isGetStarted,
  isGift as isGiftPage,
  isSinglePageCheckout,
  isSharePage,
  isPolicy,
  isCartAccountCreationCreate,
} from 'services/url'
import {
  URL_PLAN_SELECTION,
  URL_PLAN_SELECTION_PLANS,
  URL_ACCOUNT_CREATION,
  URL_CART_ACCOUNT_CREATION_CREATE,
  URL_CART_BILLING,
  URL_CART_BILLING_PAYMENT,
  URL_CART_CONFIRMATION,
  URL_CART_ACCESS_DENIED,
  URL_HOME,
  URL_GAIA_PROD,
  URL_ACCOUNT_CHANGE_PLAN,
  URL_REMOTE_ACCOUNT_CREATE,
  URL_CHECKOUT,
} from 'services/url/constants'
import {
  SET_DIALOG_COMPONENT_NAME,
  SET_DIALOG_OPTIONS,
  renderModal,
} from 'services/dialog/actions'
import { GIFT_SUBSCRIPTION_STATE } from 'services/gift'
import { TYPE_LOGIN, TYPE_CART_ABANDON } from 'services/dialog'
import { LTM, USD } from 'services/currency'
import { getPrimary } from 'services/languages'
import { addNewRelicAction } from 'services/app/_newrelic'
import { get as getConfig } from 'config'
import {
  EMAIL_PREFERENCE_FREE_ONLINE,
  EMAIL_PREFERENCE_GAIA_SPHERE,
  EMAIL_PREFERENCE_MARKETPLACE,
  EMAIL_PREFERENCE_NEWSLETTER,
  postBrooklyn as postEmailCapture,
} from 'services/email-signup'
import { NAV_TOUR_STATUS_HAS_SEEN } from 'services/feature-tracking'
import { SET_ADYEN_DROP_IN_READY } from 'services/adyen/actions'
import { ROLE_ID_AMBASSADOR } from 'services/auth-access'
import { getRemoteLoginCodeApproval } from 'services/remote-login-code/actions'
import * as actions from './actions'

const dateFormatString = 'YYYY-MM-DD'

const config = getConfig()
const fingerprintJsApiKey = _get(config, 'fingerPrintJsApiKey')
const fingerprintJsSubdomain = _get(config, 'fingerPrintJsSubdomain')
const velocityCheckActive = !!_get(config, ['features', 'checkout', 'velocityCheck'])
const planGraphQLActive = !!_get(config, ['features', 'checkout', 'planGraphQL'])

function isCheckoutPage ({ state }) {
  const { resolver } = state
  const path = resolver.getIn(['data', 'path'])
  const singlePageCheckout = isSingleCheckoutPage(path)

  return (
    isCart(path) || isPlans(path) || singlePageCheckout
  )
}

function isCheckoutFlow ({ state }) {
  const { resolver } = state
  const path = resolver.getIn(['data', 'path'])
  const singlePageCheckout = isSingleCheckoutPage(path)

  return (
    (isCart(path)
      || isPlans(path)
      || isGo(path)
      || singlePageCheckout
    )
    && !planGraphQLActive
  )
}

function isCartAccessDeniedPage ({ state }) {
  const { resolver } = state
  const path = resolver.getIn(['data', 'path'])

  return (
    isCartAccessDenied(path)
  )
}

function isAuthenticatedCheckout ({ state }) {
  const { resolver, auth } = state
  const path = resolver.getIn(['data', 'path'])
  const singlePageCheckout = isSingleCheckoutPage(path)

  return (
    (isPlans(path)
    || path === URL_ACCOUNT_CREATION
    || path === URL_CART_ACCOUNT_CREATION_CREATE
    || path === URL_CART_BILLING
    || path === URL_CART_BILLING_PAYMENT
    || singlePageCheckout)
    && auth.get('jwt')
  )
}

function isAnonymousCheckout ({ state }) {
  const { resolver, auth } = state
  const path = resolver.getIn(['data', 'path'])
  const singlePageCheckout = isSingleCheckoutPage(path)

  return (
    (isPlans(path)
    || path === URL_ACCOUNT_CREATION
    || path === URL_CART_ACCOUNT_CREATION_CREATE
    || path === URL_CART_BILLING
    || path === URL_CART_BILLING_PAYMENT
    || singlePageCheckout)
    && !auth.get('jwt')
  )
}

function isAccountCreatePage ({ state }) {
  const { resolver } = state
  const path = resolver.getIn(['data', 'path'])
  const singlePageCheckout = isSingleCheckoutPage(path)

  return (
    path === URL_CART_ACCOUNT_CREATION_CREATE
      || path === URL_REMOTE_ACCOUNT_CREATE
      || singlePageCheckout
  )
}

function isRemoteAccountCreatePage ({ state }) {
  const { resolver } = state
  const path = resolver.getIn(['data', 'path'])

  return (
    path === URL_REMOTE_ACCOUNT_CREATE
  )
}

function isCartPaymentPage ({ state }) {
  const { resolver } = state
  const path = resolver.getIn(['data', 'path'])
  const singlePageCheckout = isSingleCheckoutPage(path)

  return (
    path === URL_CART_BILLING_PAYMENT
    || singlePageCheckout
  )
}

function isCartConfirmationPage ({ state }) {
  const { resolver } = state
  const path = resolver.getIn(['data', 'path'])

  return (
    path === URL_CART_CONFIRMATION
  )
}

function isSingleCheckoutPage (path) {
  return isSinglePageCheckout(path)
    && !!getConfig().features.singlePageCheckout
}

function renderCartAbandon ({ state }) {y((item) => pmSectionItemHasData({
    item, language, videos, series, term,
  }))
}

/**
 * When all the page manager section tabs have data or the items are empty returns true
 * @param {Object} options The options
 * @param {List} options.tabs The page manager section tabs
 * @param {Map} options.videos The videos state
 * @param {Map} options.series The series state
 * @param {Map} options.term The term state
 * @param {String} options.language The language
 * @param {Number} options.tabContentMaxItems The maximum number of items per row to limit
 * the data checked for the tab content
 * @returns {Boolean} True when all the section items have data or the items are empty
 */
export function pmSectionTabsHaveData (options = {}) {
  const {
    tabs = List(),
    videos = Map(),
    series = Map(),
    term = Map(),
    language = EN,
    tabContentMaxItems = MAX_ROW_ITEMS,
  } = options
  if (tabs.isEmpty()) {
    return true
  }
  return tabs.every((tab) => pmSectionItemsHaveData({
    items: (tab.get('tabContent') || List()).slice(0, tabContentMaxItems),
    videos,
    series,
    term,
    language,
  }))
}

/**
 * Given page manager section state get the tabs
 * @param {Object} options The options
 * @param {List} options.pmSection The page manager section state
 * @param {Map} options.sectionId The section id
 * @returns {Boolean} True when all the section items have data or the items are empty
 */
export function getPmSectionTabs (options = {}) {
  const { sectionId, pmSection = Map() } = options
  if (!sectionId || !Map.isMap(pmSection)) {
    return List()
  }
  return pmSection.getIn([sectionId, 'data', 'data', 'tabs']) || List()
}

/**
 * Given page manager section state get the processing value
 * @param {Object} options The options
 * @param {List} options.pmSection The page manager section state
 * @param {Map} options.sectionId The section id
 * @returns {Boolean|undefined} The processing value
 */
export function getPmSectionProcessing (options = {}) {
  const { sectionId, pmSection = Map() } = options
  return pmSection.getIn([sectionId, 'processing'])
}

/**
 * Given page manager section state get the type
 * @param {Object} options The options
 * @param {List} options.pmSection The page manager section state
 * @param {Map} options.sectionId The section id
 * @returns {String|undefined} The processing value
 */
export function getPmSectionType (options = {}) {
  const { sectionId, pmSection = Map() } = options
  return pmSection.getIn([sectionId, 'data', 'type'])
}

/**
 * Given page manager section state get the displayMode
 * @param {Object} options The options
 * @param {List} options.pmSection The page manager section state
 * @param {Map} options.sectionId The section id
 * @returns {String} displayMode
 */
export function getPmSectionDisplayMode (options = {}) {
  const { sectionId, pmSection = Map() } = options
  return pmSection.getIn([sectionId, 'data', 'data', 'displayMode'])
}

/**
 * Given page manager section state get the data
 * @param {Object} options The options
 * @param {List} options.pmSection The page manager section state
 * @param {Map} options.sectionId The section id
 * @returns {Map|undefined} The processing value
 */
export function getPmSectionData (options = {}) {
  const { sectionId, pmSection = Map() } = options
  return pmSection.getIn([sectionId, 'data'])
}

/**
 * Given page manager section data created
 * @param {Object} options The options
 * @param {List} options.pmSection The page manager section state
 * @param {Map} options.sectionId The section id
 * @returns {Date|undefined} The processing value
 */
export function getPmSectionDataCreated (options = {}) {
  const { sectionId, pmSection = Map() } = options
  return pmSection.getIn([sectionId, 'dataCreated'])
}

/**
 * Given page manager section error value
 * @param {Object} options The options
 * @param {List} options.pmSection The page manager section state
 * @param {Map} options.sectionId The section id
 * @returns {Error|undefined} The processing value
 */
export function getPmSectionError (options = {}) {
  const { sectionId, pmSection = Map() } = options
  return pmSection.getIn([sectionId, 'error'])
}

/**
 * Given page manager section error created
 * @param {Object} options The options
 * @param {List} options.pmSection The page manager section state
 * @param {Map} options.sectionId The section id
 * @returns {Date|undefined} The processing value
 */
export function getPmSectionErrorCreated (options = {}) {
  const { sectionId, pmSection = Map() } = options
  return pmSection.getIn([sectionId, 'errorCreated'])
}

/**
 * Given page manager section state get the done value i.e.
 * when all dependacies are loaded
 * @param {Object} options The options
 * @param {List} options.pmSection The page manager section state
 * @param {Map} options.sectionId The section id
 * @returns {Boolean} The processing value
 */
export function getPmSectionDone (options = {}) {
  const { sectionId, pmSection = Map() } = options
  return pmSection.getIn([sectionId, 'done'])
}

export function getTitleForCustomRows (item, language, videos, series, terms) {
  const itemId = item.get('contentId')
  const itemType = item.get('contentType')
  let store
  switch (itemType) {
    case 'video':
      store = videos
      break
    case 'series':
      store = series
      break
    case 'person':
      store = terms
      break
    case 'tag':
      store = terms
      break
    default:
  }

  const title = store && store.getIn([getSafeNodeId(itemId), language, 'data', 'title'])
  return `${itemId} | ${title}`
}

export function sendRowImpressionGA4Event (options) {
  const {
    sectionIndex = null,
    rowPlacement = null,
    rowType,
    visibilityRules,
    setDefaultGa4Event,
    unsetIndexes,
    items = List(),
    adminTitle,
    language,
    videoStore,
    seriesStore,
    termsStore,
    visibleIndexes,
    uiLocation = UI_LOCATION_MEMBER_HOME,
    tilesV2GraphqlActive = false,
  } = options
  const countItem = []
  const tileInfos = unsetIndexes.map((index, i) => {
    const itemsList = List.isList(items) ? items : List()
    const item = itemsList.get(index) || Map()
    const itemInfo = tilesV2GraphqlActive
      ? `${item.get('contentId')} | ${item.get('title')}`
      : getTitleForCustomRows(item, language, videoStore, seriesStore, termsStore)
    let itemInfoImpression = itemInfo
    itemInfoImpression = itemInfoImpression.split(' | ')
    itemInfoImpression[0] = i
    itemInfoImpression = itemInfoImpression.join(' | ')
    countItem[i] = [itemInfoImpression]
    return itemInfo
  })

  const eventData = ROW_IMPRESSION_GA4_EVENT
    .mergeDeep({
      row_placement: rowPlacement,
      row_name: adminTitle,
      row_number: sectionIndex,
      row_type: rowType,
      visible_tiles: visibleIndexes,
      visibility_rules: visibilityRules,
      content_info_array: tileInfos.join(' | '),
      ui_location: uiLocation,
    })

  setDefaultGa4Event(eventData)
}

export function preventSectionDataLoad (options) {
  const { now, dataCreated } = options

  if (!now || !dataCreated) {
    return false
  }

  if (!now.getTime || !dataCreated.getTime) {
    return false
  }

  return now.getTime() < (dataCreated.getTime() + GET_PM_SECTION_DATE_CACHE_TIME)
}
